import { Component, OnInit, AfterContentInit, Input} from '@angular/core';
import { AauthService } from 'src/app/services/aauth.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { Platform, NavController } from '@ionic/angular';

import { environment } from 'src/environments/environment';
import { ModelService } from 'src/app/services/model.service';

@Component({
  selector: 'app-headerbar',
  templateUrl: './headerbar.component.html',
  styleUrls: ['./headerbar.component.scss'],
})
export class HeaderbarComponent implements OnInit, AfterContentInit {

  @Input() cls: string;
  @Input() title: any;
  @Input() titleTranslate: string;
  @Input() titleParams: any;
  @Input() logo: string;
  
  @Input() buttonMenu: string;
  @Input() buttonMenuImage: string;
  @Input() buttonBack: string;
  @Input() buttonBackRoute: string; // passar atributo sem [] ex.: <app-headerbar buttonBackRoute="rota"></app-headerbar>
  @Input() buttonAccount: string;
  @Input() buttonRefresh: string;
  @Input() isModal: string;
  @Input() modalBackIcon: string;

  modalActive: any;

  @Input() platformIos: boolean = false; 

  unitData: any;
  sideMenuLogoRendered: boolean = false;

  // private navController: any;
  // private modalController: any;
  
  // Iniciar estas variaveis sempre que carregar o construtor (assim roda tranquilo no tabs)
  // tabsContainer: any; // verificar se existe um tabs
  // titleContainer: any;
  // logoContainer:  any;

  // logoContainer: boolean = false;

  // Variaveis privadas carregadas de helpersService  
  private languageService: any;
  private menuController: any;
  private modalController: any;
  private environment: any;

  

  constructor( 
    private helpersService: HelpersService, 
    private aauthService: AauthService,
    private _platform: Platform,
    private navController: NavController,
    private modelService: ModelService
    ) 
    {
      // Checar se está logado
      this.aauthService.loggedCheck();

      // carregar padrões das variaveis
      this.cls             = 'light';
      this.title           = '';
      this.titleTranslate  = 'false'; 
      this.titleParams     = '';
      this.logo            = 'true';
      this.buttonMenu      = 'false';
      this.buttonMenuImage = 'assets/icons/';
      this.buttonBack      = 'true';
      this.buttonBackRoute = ''; // passar atributo sem [] ex.: <app-headerbar buttonBackRoute="rota"></app-headerbar>
      this.buttonAccount   = 'false';
      this.buttonRefresh   = 'false';
      this.isModal         = 'false';
      this.modalBackIcon   = 'arrow-back';
      
      // Carregar arquivos vindos do HelpersService
      this.languageService = this.helpersService.languageService;
      this.menuController = this.helpersService.menuController; 
      this.environment = this.helpersService.environment;
      this.modalController = this.helpersService.modalController;
      // this.navController = this.helpersService.navController;
      // this.modalController = this.helpersService.modalController; 

      // Checar conexão com a internet   
      // this.helpersService.networkCheck();
    
      // Iniciar variaveis adicionais do headerbar
      // this.logoContainer  = null;
      // this.titleContainer = null;

      // Pegar a logomarca de environment
      this.logo = (this.logo == 'true') ? environment.appLogo : 'false';

      // Remover classe de erro do corpo
      document.body.classList.remove('jsmx-requestError');

      // Armazenar a plataforma para mostrar, ou n, o texto do botao voltar
      this.platformIos = this._platform.is('ios');
  } 

    async ngOnInit() {

        // por padrão esconder o menu, na view mostrar caso seja necessário
        // this.menuController.enable(false)

        // Carregar o icone do menu com base na classe do toolbar
        this.buttonMenuImage += (this.cls != 'secondary' && this.cls != 'light' && this.cls != 'white') ? 'menu_contrast.svg' : 'menu.svg' ;


        // Pegar rota para retorno com base na url anterior
        if(this.buttonBackRoute == null || this.buttonBackRoute == '') {
            const routeBack = await this.helpersService.routeSnapshot('queryparams', 'backTo') || '';

            if(routeBack != '')
                this.buttonBackRoute = '/' + await this.helpersService.routeSnapshot('queryparams', 'backTo') || '';
        }


        // Setar o título
        // if(this.title  != null) {
        //   await this.titleSet();
        // } else {
        //   // Setar a logo - Pegar o arquivo de logo de environment (apenas se o não for passado um titulo)
        //   if(this.logo == 'true') this.logoSet();
        // }   
    }
    async ngAfterContentInit() {

        if(!this.unitData && !this.sideMenuLogoRendered) {
            this.unitData = await this.modelService.get('unitData');
            
            if(this.unitData)
                this.renderSideMenuLogo();
        }
    }

    renderSideMenuLogo() {

        if(this.sideMenuLogoRendered) return;

        const menuLogoContainer = document.querySelector('#jsmx-unitData');

        let logo = '';
        let text =  `<p>${this.languageService.get('SIGTURE_COURTESY_BY')}: ${this.unitData.fantasy} </p>`;

        if(this.unitData.base64Logo) {
            logo =  `<img id="jsmx-menuUnitLogo" src="${this.unitData.base64Logo}" style="max-width: 150px" />`;
        }
        
        menuLogoContainer.innerHTML = `<div class="uk-padding-small uk-text-center">${logo}${text}</div>`;

        menuLogoContainer.classList.remove('uk-hidden');

        this.sideMenuLogoRendered = true;
    }

    async close(){ 
        await this.modalController.dismiss({
            'dismissed': true,

        });
        // const { data } = await this.modalController.onWillDismiss();
        // console.log(data);
    }
  
    pageAccount() {
        return this.helpersService.routeNavigate('/profile', false, 'go', true);
    }

    async viewForceGetData() { 
        window.location.reload();
        // let newLocation: any = await this.helpersService.routeActiveGet();
        
        // if(newLocation.indexOf('forceGetData') < 1) {
        //    newLocation += (newLocation.indexOf('?') !== -1) ? '&forceGetData=true' : '?forceGetData=true'; 
        // }

        // return this.helpersService.routeNavigate(newLocation, false, 'go', true);
    }

    async backToPage() {
        this.navController.navigateBack(this.buttonBackRoute);
    }

  // async titleSet() {
  //   setTimeout( async () => {
    
  //     // Checar se possui tabs
  //     this.tabsContainer = document.querySelector('ion-tabs');

  //     // Usar o await para aguardar o elemento entrar no DOM, depois carregá-lo de forma normal na variavel
  //     this.titleContainer = await document.querySelector('#jsmx-headerbarTitle');
  //     this.titleContainer = (this.tabsContainer == null) ? document.querySelector('#jsmx-headerbarTitle') :  this.tabsContainer.querySelector('.ion-page:not(.ion-page-hidden)').querySelector('#jsmx-headerbarTitle');
      

  //     if(this.titleContainer != null) {
  //       // Traduzir o título
  //       if(this.titleTranslate == 'true' &&  this.environment.appMultilanguage == true) {
          
  //           // Converter para maiusculo
  //           this.title = this.title.toUpperCase(this.title);

  //           // trocar espaços por undderscore
  //           this.title = this.title.replace(/\s+/g, '_');

  //           console.log(this.title);

  //           this.title = await this.languageService.get(this.title);
  //       }

  //       console.log(this.title);

  //       if(this.titleContainer.textContent == '') this.titleContainer.textContent = this.title;
        
  //     }

  //   }, 25);
  // }

  // async logoSet() {
  //   setTimeout( async () => {
          
  //     // Checar se possui tabs
  //     this.tabsContainer = document.querySelector('ion-tabs');
      
  //     if(this.logoContainer == null) {

  //       // Usar o await para aguardar o elemento entrar no DOM, depois carregá-lo de forma normal na variavel
  //       this.logoContainer = await document.querySelector('#jsmx-headerbarLogo');
  //       this.logoContainer = (this.tabsContainer == null) ? document.querySelector('#jsmx-headerbarLogo') :  this.tabsContainer.querySelector('.ion-page:not(.ion-page-hidden)').querySelector('#jsmx-headerbarLogo');


  //       this.logoContainer.setAttribute('src', this.environment.appLogo) 
  //     }
  //   }, 25);
  // }

  // async pageAccount() {
  //   const modal = await this.modalController.create({
  //     component: AccountPage,
  //     componentProps: {
  //       'firstName': 'Douglas',
  //       'lastName': 'Adams',
  //       'middleInitial': 'N'
  //     }
  //   });


  //   return await modal.present().then(() => { 
  //     this.modalActive = modal;
  //     console.log(this.modalActive);
      
  //   });
  // }
}
